<page-header style="background-color: #005595"></page-header>
<mat-card>
  <mat-card-content>
    <div class="flex flex-col gap-4">
      <span style="font-size:30px">ORELAP Methods and Analytes Certification</span>
      <form [formGroup]="requestForm" (ngSubmit)="submitRequest()">
        <div class="flex flex-col gap-4">
          <div class="flex flex-row gap-2">
            <span>Search By:</span>
            <mat-radio-group formControlName="searchBy">
              <mat-radio-button color="primary" class="p-x-8" value="Analyte"> Analyte</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="AnalyteCode"> Analyte Code</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="MethodCode"> Method Code</mat-radio-button>
              <mat-radio-button color="primary" class="p-l-8" value="MethodReference"> Method Reference</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="flex flex-row gap-2 sm:flex-row">
            <mat-form-field class="w-3/10 sm:w-1/2">
              <input matInput placeholder="Search Term" formControlName="search">
              <mat-error *ngIf="requestForm.get('search').invalid">
                {{'validations.required' | translate}}
              </mat-error>
            </mat-form-field>
            <button type="submit" class="m-8" mat-raised-button color="primary">Search Analytes</button>
          </div>
          <span class="text-red-700">
            ORELAP Accredited Methods and Analytes: (Please contact the Administrator if you cannot find any methods and related analytes.)
          </span>
          <span class="text-red-700">
            Note: * Approved method under OAR or CFR (MUR)
          </span>
        </div>
      </form>
    </div>

    <div class="flex flex-col">
      <div class="flex flex-row">
        <mat-form-field class="w-3/10 sm:w-full">
          <input matInput
                 (keyup)="filterTable($event.target.value)"
                 placeholder="Filter" />
        </mat-form-field>
      </div>
      <mat-table [dataSource]="dataSource"
                  matSort
                  #TableSort="matSort"
                  class="mat-elevation-z8 w-full">
        <ng-container matColumnDef="analyteCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Analyte Code</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Analyte Code</span>
            {{list.analyteCode}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="analyte">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Analyte</span>
            {{list.analyte}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="methodCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Method Code</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Method Code</span>
            {{list.methodCode}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="methodReference">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Method Reference</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Method Reference</span>
            {{list.methodReference}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="revision">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Revision</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Revision</span>
            {{list.revision}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="approved">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Approved</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Approved</span>
            <mat-checkbox [disabled]="true"
                          [checked]="list.approved">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="air">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Air</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Air</span>
            <mat-checkbox [disabled]="true"
                          [checked]="list.air">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="drinkingWater">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Drinking Water</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Drinking Water</span>
            <mat-checkbox [disabled]="true"
                          [checked]="list.drinkingWater">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="nonPotable">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Non-Potable</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Non-Potable</span>
            <mat-checkbox [disabled]="true"
                          [checked]="list.nonPotable">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="solids">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Solids</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Solids</span>
            <mat-checkbox [disabled]="true"
                          [checked]="list.solids">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tissue">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Tissue</mat-header-cell>
          <mat-cell *matCellDef="let list">
            <span class="mobile-label">Tissue</span>
            <mat-checkbox [disabled]="true"
                          [checked]="list.tissue">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                     #TablePaginator="matPaginator"
                     showFirstLastButtons></mat-paginator>
    </div>

  </mat-card-content>
</mat-card>
